import React from 'react'
import {Control, Controller, FieldErrors, FieldValues, Path, RegisterOptions} from 'react-hook-form'
import {formatAustralianMobileInput} from '../../application/component/renter-home/renterHomeUtils'
import {getFieldError} from './getFieldError'

type MobileNumberInputProps<T extends FieldValues> = {
  name: Path<T>
  label?: string
  placeholder?: string
  required?: boolean
  control: Control<T>
  errors?: FieldErrors<T>
  className?: string
  inputClassName?: string
  disabled?: boolean
  rules?: RegisterOptions<T, Path<T>>
}

export const MobileNumberInput = <T extends FieldValues>({
  name,
  label,
  placeholder = '0412 345 678',
  control,
  required = false,
  errors,
  className = '',
  inputClassName = '',
  disabled = false,
  rules,
}: MobileNumberInputProps<T>) => {
  const error = getFieldError(errors, name)

  return (
    <div className={`mb-5 ${className}`.trim()}>
      {label && (
        <label className='form-label fw-semibold' htmlFor={String(name)}>
          {label} {required && <span className='text-danger'>*</span>}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({field}) => (
          <input
            id={String(name)}
            type='tel'
            inputMode='tel'
            autoComplete='tel'
            placeholder={placeholder}
            className={`form-control ${inputClassName} ${error ? 'is-invalid' : ''}`.trim()}
            disabled={disabled}
            name={field.name}
            ref={field.ref}
            onBlur={field.onBlur}
            value={field.value ?? ''}
            onChange={(event) => {
              field.onChange(formatAustralianMobileInput(event.target.value))
            }}
          />
        )}
      />

      {error && <div className='text-danger mt-1'>{error.message}</div>}
    </div>
  )
}
